export enum UserStatus {
    Active = 'ACTIVE',
    Deactivated = 'DEACTIVATED',
    Unregistered = 'UNREGISTERED',
    Invited = 'INVITED',
}
